import React, { useState, useContext, useEffect } from "react";
import LoadingComponent from "../loading_component";
import { EmplContext } from "../Login_Page/Login_Page/LoginPage";
import configData from "../../../src/config.json";
import Swal from "sweetalert2";
import { ColorContext } from "../../ColorContext";
import "./TeamLeaveBalance.css";

const formatLeaveMetric = (value) => {
  const number = Number(value || 0);
  return Number.isFinite(number) ? number.toFixed(2).replace(/\.00$/, "") : "0";
};

export default function TeamLeaveBalance() {
  const { resultData } = useContext(EmplContext);
  const { bgColor } = useContext(ColorContext);
  const employee_id = resultData.employee_id || 0;

  const [teamMembers, setTeamMembers] = useState([]);
  const [load, setLoading] = useState(true);

  const fetchData = async () => {
    try {
      const secretKey = configData.SECRET_Key;
      const requestData = { employee_id, secretKey };
      const response = await fetch(`${configData.SERVER_URL}/team-leave-balance`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestData),
      });
      const data = await response.json();
      const result = JSON.parse(data.result);
      if (result.success === true) {
        setTeamMembers(result.team_members || []);
      } else {
        Swal.fire({ icon: "error", title: result.message || "Failed to fetch team leave balance" });
      }
    } catch (error) {
      console.error("Error:", error);
      Swal.fire({ icon: "error", title: String(error) });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [employee_id]);

  const avatarLetter = (name) => {
    return (name || "U")
      .split(" ")
      .map((part) => part[0])
      .slice(0, 2)
      .join("")
      .toUpperCase();
  };

  return (
    <>
      {load ? (
        <div className="d-flex justify-content-center" style={{ paddingTop: 100 }}>
          <LoadingComponent />
        </div>
      ) : (
        <div className="content-wrapper">
          <div className="ep_content">
            <div className="row" style={{ paddingTop: 50 }}>
              <div className="col-md-12">
                <div className="my-team-header">
                  <h2 className="my-team-title">My Team</h2>
                </div>
                <div className="card team-table-card shadow-sm border-0">
                  <div className="card-body p-0">
                    <div className="table-responsive">
                      <table className="table table-hover align-middle mb-0">
                        <thead>
                          <tr>
                            <th>
                              <i className="fa-solid fa-user me-2" /> Name
                            </th>
                            <th>Department</th>
                            <th>Designation</th>
                            <th>Leave Balance</th>
                            <th>RH Balance</th>
                            <th>Email</th>
                            <th>Phone</th>
                          </tr>
                        </thead>
                        <tbody>
                          {teamMembers.map((member) => (
                            <tr key={member.id} className="team-table-row">
                              <td className="team-table-cell">
                                <div className="d-flex align-items-center">
                                  <div
                                    className="team-avatar-sm"
                                    style={{
                                      backgroundColor: bgColor || "#6c757d",
                                      color: "#fff",
                                    }}
                                  >
                                    {avatarLetter(member.name)}
                                  </div>
                                  <span className="ms-2">{member.name}</span>
                                </div>
                              </td>
                              <td className="team-table-cell">{member.department || "—"}</td>
                              <td className="team-table-cell">
                                {member.job_title || member.job || "—"}
                              </td>
                              <td className="team-table-cell team-leave-cell">
                                {formatLeaveMetric(member.leave_balance)}
                              </td>
                              <td className="team-table-cell team-rh-cell">
                                {formatLeaveMetric(member.rh_balance)}
                              </td>
                              <td className="team-table-cell">
                                {member.work_email || "—"}
                              </td>
                              <td className="team-table-cell">
                                {member.mobile_phone || member.work_phone || "—"}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
